import React, { Component } from 'react';
import { MegaMenu } from 'primereact/megamenu';
import OperationLayerType from './OperationLayerType';
import LayerTypeCreateComponent from './LayerTypeCreateComponent';
import { TableCrud, TableManagement } from '../CustomerTable';
import { Card } from 'primereact/card';
import TreeAuthorization from './TreeAuthorization';
import CreateTreeStructureComponent from './CreateTreeStructureComponent';
import {  useNavigate } from 'react-router-dom';
class SidebarComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    items = [
        window.Object.checkPermissions(["tree_authorization"])&&  {
            label: 'Ağaç Yapısı Yetkilendirme',
            icon: 'pi pi-cog',
            command: (e) => {
                this.handleCommand(<TreeAuthorization
                    crudApiUrl={process.env.REACT_APP_CRUD_API_URL}
                    dynamicApiUrl={process.env.REACT_APP_DYNAMICTABLE_API_URL}

                />, e)
            }
        },
        window.Object.checkPermissions(["current_tree_structure"]) &&   {
            label: 'Mevcut Ağaç Yapısı',
            icon: 'pi pi-list',
            command: (e) => {
                // Handle Home button click
                this.handleCommand(<OperationLayerType />, e)

            }
        },
  
        window.Object.checkPermissions(["creating_tree_break"])&&  {
            label: 'Ağaç Kırılımı Oluşturma Sayfası',
            icon: 'pi pi-cog',
            command: (e) => {
                this.handleCommand(<CreateTreeStructureComponent />, e)
            }
        },
        {
            label: 'Harita Sayfası',
            icon: 'pi pi-backward',
            command: (e) => {
                window.location.href = process.env.PUBLIC_URL+"/";
            }
        }
        ,
        window.Object.checkPermissions(["table_management","table_management_get_all"]) &&  {
            label: 'Tablo Yönetimi',
            icon: 'pi pi-table',
            command: (e) => {
                this.handleCommand(<>

                    <Card title="Tablo Yönetimi">

                        <TableManagement
                            isMap={false}
                            apiUrl={process.env.REACT_APP_DYNAMICTABLE_API_URL}                                 
                            isEdit={true}
                            isDataAdd={true}
                            layerName="active_table_layer"
                            customerTableInfoId="customer-table-info-div"
                            tokenKey="bs-core-token"
                            isPopup={false}                
                            onShowTable={(e) => {
                                //this.setState({ customerQueryWindow: true });
                            }} />
                    </Card>
                </>, e)
            }
        }
    ];


    handleCommand = (command, event) => {
        event.originalEvent.stopPropagation();
        this.props.setSelectedComponent(command);
    }


    render() {
        return (
            <div className="card" >
                <MegaMenu model={this.items.filter(x => x)} orientation="vertical" style={{ width: '200px', height: '80%', position: 'fixed' }} />

            </div>
        );
    }
}

export default SidebarComponent;